import { Button } from "@mui/material";

interface DefaultButtonProps {
    onClick?: () => void;
    text: string;
    /** Kept for API compatibility - every button is a pill now, this is a no-op. */
    rounded?: boolean;
    /** primary = solid Shufl blue, secondary = dark fill, ghost = text-only. */
    variant?: "primary" | "secondary" | "ghost";
    size?: "small" | "medium" | "large";
    fullWidth?: boolean;
    disabled?: boolean;
}

const sizing = {
    small: { padding: "7px 16px", fontSize: 13 },
    medium: { padding: "10px 26px", fontSize: 15 },
    large: { padding: "14px 38px", fontSize: 16 },
};

export default function DefaultButton(props: DefaultButtonProps) {
    const { onClick, text, variant = "primary", size = "medium", fullWidth, disabled } = props;

    const muiVariant = variant === "ghost" ? "text" : "contained";
    const color = variant === "secondary" ? "secondary" : "primary";

    return (
        <Button
            variant={muiVariant}
            color={color}
            onClick={onClick}
            fullWidth={fullWidth}
            disabled={disabled}
            sx={{
                ...sizing[size],
                whiteSpace: "nowrap",
                ...(variant === "ghost" && {
                    color: "text.secondary",
                    "&:hover": { color: "text.primary" },
                }),
            }}
        >
            {text}
        </Button>
    );
}
